import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["getFound"];
import React from 'react';
import { shallowEqual, useSelector, useStore } from 'react-redux';
import createBaseRouter from './createBaseRouter';
import { jsx as _jsx } from "react/jsx-runtime";
export default function createConnectedRouter(_ref) {
  var _ref$getFound = _ref.getFound,
    getFound = _ref$getFound === void 0 ? function (_ref2) {
      var found = _ref2.found;
      return found;
    } : _ref$getFound,
    options = _objectWithoutPropertiesLoose(_ref, _excluded);
  var Router = createBaseRouter(options);
  var getFoundState = function getFoundState(state) {
    var _getFound = getFound(state),
      match = _getFound.match,
      resolvedMatch = _getFound.resolvedMatch;
    return {
      match: match,
      resolvedMatch: resolvedMatch
    };
  };
  function ConnectedRouter(props) {
    var store = useStore();
    var foundState = useSelector(getFoundState, shallowEqual);
    return /*#__PURE__*/_jsx(Router, Object.assign({}, props, foundState, {
      store: store
    }));
  }
  return ConnectedRouter;
}